import React from 'react';
import { Carousel, Image } from 'antd';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { getChildrenToRender } from './utils';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
// import styles from '../../pages/home/less/carousel5.less';

// import { url } from 'inspector';

class Banner5 extends React.PureComponent {
  render() {

    console.error("this.props:  ", this.props)
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;
    console.error("tagProps: ", tagProps);

    const animType = {
      queue: 'bottom',
      one: {
        y: '+=30',
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
      },
    };
    const childrenToRender = dataSource.blockWrapper.children.map((item, i) => (
      <div {...item} key={i.toString()} style={{ width: '100%', height: '500px'}}>
       

        {/* <Image  height={500} width={'100%'} preview={false} src={imageList[i]}> */}
          <a {...item.children} >
  {item.children.children.map(getChildrenToRender)}
</a>
        {/* </Image> */}

      </div>
    ));
    return (
      <div {...tagProps} {...dataSource.wrapper} >

        {/* <div {...dataSource.page}> */}



        <QueueAnim
          key="queue"
          type="bottom"
          leaveReverse
          interval={100}
          width={'100%'}
          style={{}}
          // component={Row}
          {...dataSource.blockWrapper}
        >


          <Carousel autoplay>
            {childrenToRender}
          </Carousel>

        </QueueAnim>

        {/* </div> */}


      </div>
    );
  }
}
export default Banner5;
